module.exports = "<div class=\"home-bg\">\n  <p>\n    donate works!\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/donate/donate.component.html
// module id = ./src/app/donate/donate.component.html
// module chunks = main